import React from 'react';
import {
  User, Users, X, Heart, Info, Check, Compass, Calendar, DollarSign, FileText,
  Truck, Shield, MapPin, Home, Grid, Zap, Sun, Eye, XCircle, Sliders, Clock,
  TrendingUp, TrendingDown, Map, Wrench, ChevronsDown, CheckCircle,
  ArrowRightCircle, RotateCcw, CornerDownRight, Bell, Send, Mail, Flag, Star,
  Briefcase, Search, ArrowRight, Filter, Layers, Play, Pause, SkipForward,
  SkipBack, ChevronLeft, ChevronRight, MessageCircle, Sparkles, BookOpen,
  Sunrise, Award, Maximize2, Bookmark, Lock, PieChart, Camera, CheckSquare,
  Edit3, Edit2, Target, List, Radio, Phone, ExternalLink, UserCheck,
  AlertCircle, ArrowUpRight, HelpCircle, Key, Percent, Repeat, PlusCircle,
  ChevronDown, ChevronUp, GitBranch, Square, Copy, ShoppingBag,
  MoreHorizontal, Coffee, Archive, Box, Download, Upload, Droplet,
  Thermometer, Navigation, Plus, CornerUpRight,
} from 'lucide-react';

// Feather-namen (uit de originele app) → lucide-react
const MAP = {
  user: User, users: Users, x: X, heart: Heart, info: Info, check: Check,
  compass: Compass, calendar: Calendar, 'dollar-sign': DollarSign,
  'file-text': FileText, truck: Truck, shield: Shield, 'map-pin': MapPin,
  home: Home, grid: Grid, zap: Zap, sun: Sun, eye: Eye, 'x-circle': XCircle,
  sliders: Sliders, clock: Clock, 'trending-up': TrendingUp,
  'trending-down': TrendingDown, map: Map, tool: Wrench,
  'chevrons-down': ChevronsDown, 'check-circle': CheckCircle,
  'arrow-right-circle': ArrowRightCircle, 'rotate-ccw': RotateCcw,
  'corner-down-right': CornerDownRight, bell: Bell, send: Send, mail: Mail,
  flag: Flag, star: Star, briefcase: Briefcase, search: Search,
  'arrow-right': ArrowRight, filter: Filter, layers: Layers, play: Play,
  pause: Pause, 'skip-forward': SkipForward, 'skip-back': SkipBack,
  'chevron-left': ChevronLeft, 'message-circle': MessageCircle,
  sparkles: Sparkles,
  'book-open': BookOpen, sunrise: Sunrise, award: Award,
  'maximize-2': Maximize2, bookmark: Bookmark, lock: Lock,
  'pie-chart': PieChart, camera: Camera, 'check-square': CheckSquare,
  'chevron-right': ChevronRight, 'edit-3': Edit3, 'edit-2': Edit2,
  target: Target, list: List, radio: Radio, phone: Phone,
  'external-link': ExternalLink, 'user-check': UserCheck,
  'alert-circle': AlertCircle, 'arrow-up-right': ArrowUpRight,
  'help-circle': HelpCircle,
  key: Key, percent: Percent, repeat: Repeat, 'plus-circle': PlusCircle,
  'chevron-down': ChevronDown, 'chevron-up': ChevronUp,
  'git-branch': GitBranch, square: Square, copy: Copy,
  'shopping-bag': ShoppingBag, 'more-horizontal': MoreHorizontal,
  coffee: Coffee, archive: Archive, box: Box, download: Download,
  upload: Upload, droplet: Droplet, thermometer: Thermometer,
  navigation: Navigation, plus: Plus, 'corner-up-right': CornerUpRight,
};

export default function Icon({ name, size = 16, color = '#000', style, strokeWidth = 2.2 }) {
  const Cmp = MAP[name] || Info;
  return <Cmp size={size} color={color} style={style} strokeWidth={strokeWidth} />;
}
